export default "__VITE_ASSET__Cx4izmZk__"